<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
import { getQueryString } from './utils'

export default {
    name: 'App',
    components: {},
    created() {
        var page = getQueryString('page')
        if (page) {
            this.$router.replace({ path: '/' + page })
        }
        // else {
        //     var num = Math.random() * 2
        //     console.log("num:"+num)
        //     if (num >= 1) {
        //         this.$router.replace({ path: '/indexb' })
        //     } else {
        //         this.$router.replace({ path: '/indexa' })
        //     }
        //     // this.$router.replace({ path: '/' })
        //     // this.getNumber()
        // }
        // // this.$router.replace({ path: '/detaila' })
    },
    mounted() {},
    methods: {}
}
</script>

<style>
#app {
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    position: fixed;
    background-color: #000;
    /* position: relative;
    width: 100%;
    height: 100%; */
    overflow-x: hidden;
    overflow-y: scroll;

    /* position: relative;
    left: 0;
    top: 0;
    background-color: #000;
    overflow-x: hidden; */
}
</style>
